import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { QuestionTypeEnum } from '../../models/question-type';
import { HistoryService } from '../../services/history.service';
import { MetaService } from '../../services/meta.service';
import { ProductService } from '../../services/product.service';
import { QaService } from '../../services/qa.service';
import { StartupService } from '../../services/startup.service';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Empty } from '../../models/utils.model';
import { AnswerInfoService } from '../../services/answer-info.service';
import { Tile, ArticleTypeEnum } from '../../models/data.model';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BuyOnlineService } from '../../services/buy-online.service';
import { WoodTypeEnum } from '../../models/wood-type';

@Component({
  selector: 'app-product-recommendation',
  templateUrl: './product-recommendation.component.html',
  styleUrls: ['./product-recommendation.component.scss']
})
export class ProductRecommendationComponent implements OnInit {
  backgroundUrl: SafeStyle;
  showAnimateClassFast: boolean = true;
  showAnimateClassSlow: boolean = true;
  showEmailModal: boolean = false;
  recommendationText: string;
  @ViewChildren('answerContent') answerContent: QueryList<any>;
  tiles: Tile[];
  buyOnlineLink: string;

  constructor(
    public qaService: QaService,
    private route: ActivatedRoute,
    public productService: ProductService,
    public startupService: StartupService,
    private historyService: HistoryService,
    public metaTagService: MetaService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private answerInfoService: AnswerInfoService,
    private http: HttpClient,
    private buyOnlineService: BuyOnlineService
  ) {
   }

  ngOnInit() {
    this.getBoardImageUrl().subscribe(x => {
      this.backgroundUrl = this.sanitizer.bypassSecurityTrustStyle(`url('${x}')`);
      this.qaService.paintedBoard = x;

      if (
        this.qaService.answers.selectedAnswers.find(x =>
          x.WoodTypeFilter === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.Composite)
        )
      ) {
        this.backgroundUrl = this.sanitizer.bypassSecurityTrustStyle(`url('${x.replace('composite-wood', 'pressure-treated-lumber')}')`);
      }
    });

    this.route.params.subscribe(params => {
      this.productService.getProduct(params['nodealias']).subscribe(response => {
        this.historyService.next(this.router.url, this.qaService.answers);
        this.qaService.updateProgress('100');
        this.qaService.selectedProduct = response;

        this.metaTagService.setMetaTags(
          // this.qaService.selectedProduct.DocumentPageTitle,
          '',
          this.qaService.selectedProduct.DocumentPageDescription,
          this.qaService.selectedProduct.DocumentPageKeyWords
        );
        this.dataLayerPush(undefined, undefined, 'product', this.qaService.selectedProduct.NodeName);
        this.dataLayerPush(undefined, undefined, 'color', this.qaService.answers.selectedColor.Name);
        this.dataLayerPush(undefined, undefined, 'zipcode', this.qaService.answers.postalCode);
        this.dataLayerPush(undefined, undefined, 'project', this.qaService.getProject());

        const myWoodType = this.answerInfoService.getSelectedWoodType();
        const myProductFilter = this.qaService.selectedProduct.ProductFilter;
        const myOpacity = this.qaService.answers.selectedColor.Opacity;
        const myCulture = window.location.href.split('/')[3];

        const text = this.startupService.startupData.ProductRecommendationText.find(p => {
          return p.WoodType === myWoodType &&
                  p.ProductFilter === myProductFilter &&
                  p.Opacity === myOpacity &&
                  p.Culture === myCulture;
        });

          if (this.qaService.selectedProduct.NodeName === "Paramount - Semi- Transparent / Semi-Solid"){
            if (this.qaService.answers.selectedColor.BaseProduct !== 0){
              this.qaService.selectedProduct.Image = this.qaService.answers.selectedColor.BackgroundImage;
            }            
          }
          else if (this.qaService.selectedProduct.NodeName === "Paramount - Solid"){
            if (this.qaService.answers.selectedColor.BaseProduct !== 0){
              this.qaService.selectedProduct.Image = this.qaService.answers.selectedColor.BackgroundImage;
            }            
          }

        this.recommendationText = text.Text;

        this.buyOnlineLink = this.buyOnlineService.getBuyOnlineLink(this.qaService.selectedProduct.NodeName,
          this.qaService.answers.selectedColor.Opacity,
          this.qaService.answers.selectedColor.Name);

        for (let i = 0; i < this.startupService.startupData.ProductScreen.Tiles.length; i++) {
          const tile = this.startupService.startupData.ProductScreen.Tiles[i];

          if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.StepByStep) === tile.ArticleFilter) {
            const filtered = this.startupService.startupData.ArticleLinks.find(x => x.ArticleFilter === tile.ArticleFilter &&
              x.ProjectFilter === this.answerInfoService.getSelectedProject() &&
              x.OpacityFilter === this.qaService.answers.selectedColor.Opacity &&
              x.WoodTypeFilter === this.answerInfoService.getSelectedWoodType() &&
              x.WhatLookFilter === this.answerInfoService.getSelectedWoodLook() &&
              x.Culture === myCulture );
            if (filtered) {
              this.startupService.startupData.ProductScreen.Tiles[i].Href = filtered.ArticleUrl;
            }
          }

          if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.ShoppingList) === tile.ArticleFilter) {
            const filtered = this.startupService.startupData.ArticleLinks.find(x => x.ArticleFilter === tile.ArticleFilter &&
              x.ProjectFilter === this.answerInfoService.getSelectedProject() &&
              x.OpacityFilter === this.qaService.answers.selectedColor.Opacity &&
              x.WoodTypeFilter === this.answerInfoService.getSelectedWoodType() &&
              x.Culture === myCulture);
            if (filtered) {
              this.startupService.startupData.ProductScreen.Tiles[i].Href = filtered.ArticleUrl;
            }
          }

          if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.Calculator) === tile.ArticleFilter) {
            const filtered = this.startupService.startupData.ArticleLinks.find(x =>
              x.ArticleFilter === tile.ArticleFilter &&
              x.Culture === myCulture &&
              x.ProjectFilter === this.answerInfoService.getSelectedProject()
            );
            if (filtered) {
              this.startupService.startupData.ProductScreen.Tiles[i].Href = filtered.ArticleUrl;
            }
          }

          if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.Video) === tile.ArticleFilter) {
            const filtered = this.startupService.startupData.ArticleLinks.find(x =>
              x.ArticleFilter === tile.ArticleFilter &&
              x.Culture === myCulture &&
              x.ProjectFilter === this.answerInfoService.getSelectedProject()
            );
            if (filtered) {
              this.startupService.startupData.ProductScreen.Tiles[i].Href = filtered.ArticleUrl;
            }
          }



          // TODO: Meeting go live last minute requirement
          // if (this.qaService.selectedProduct.DocumentPageTitle.toLowerCase() === 'smart guard cear') {
          //   if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.StepByStep) === tile.ArticleFilter) {
              // tslint:disable-next-line: max-line-length
              // this.startupService.startupData.ProductScreen.Tiles[i].Href = 'http://www.olympic.com/inspiration/projectpro/step-by-step-smartguard-clear';
            // }

            // if (this.answerInfoService.getArticleTypeGuid(ArticleTypeEnum.ShoppingList) === tile.ArticleFilter) {
              // tslint:disable-next-line: max-line-length
              // this.startupService.startupData.ProductScreen.Tiles[i].Href = 'http://www.olympic.com/inspiration/projectpro/shopping-list-for-sg';
            // }
          // }
        }

        setTimeout(x => {
          this.answerContent.forEach(el => {
            el.nativeElement.style.marginTop = -(el.nativeElement.offsetHeight / 2) + 'px';
          });
        }, 250);
      });
    });



    setTimeout(x => this.showAnimateClassFast = false, 1000);
    setTimeout(x => this.showAnimateClassSlow = false, 1500);
  }

  getBoardImageUrl() {
    let queryString: HttpParams = new HttpParams();
    queryString = queryString.append('woodType', this.answerInfoService.getSelectedWoodType());
    queryString = queryString.append('opacity', this.qaService.answers.selectedColor.Opacity);
    queryString = queryString.append('colorName', this.qaService.answers.selectedColor.Name);

    return this.http.get<string>(`${environment.apiUrl}/get-board-image`, { params: queryString });
  }

  openModal() {
    this.showEmailModal = true;
  }
  onShow(isShown: boolean) {
    this.showEmailModal = isShown;
  }

  dataLayerPush(event: string = 'gtm.click', t: string = 'output', d1: string = '', d2: string = '', d3: string = '', d4: string = '') {
    const dataLayer = window['dataLayer'] || [];

    dataLayer.push({
      gtm: {
        element: {
          dataset: {
            t: t,
            d1: d1,
            d2: d2,
            d3: d3,
            d4: d4
          }
        }
      },
      event: event
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/product-recommendation/product-recommendation.component.ts